<template>
<section>
    <n-alert v-if="exchangeMeta2Info && !disabled" class="rounded-md mb-4" type="warning" size="small">
        <div class="notes text-xs" v-html="exchangeMeta2Info"></div>
    </n-alert>

    <div class="flex items-center justify-between">
        <rb-title
            :help="help"
            :status="status"
            :disabled="disabled"
            :help-warning="exchangeMetaInfo"
            :label="mainTitle" />

        <rb-radio-group
            v-model:value="apiOptions"
            :options="options" />
    </div>

    <n-alert v-if="!apiKeysRefs?.length && !disabled" class="rounded-md mt-4" type="warning" size="small">
        <div 
            class="notes text-xs"
            v-html="getNoKeysAvailableInfo(bots.localization?.no_keys_available || 'Для биржи {{}} нет доступных ключей. Создайте новый.')"></div>
    </n-alert>

    <section v-if="errors.lengthh && !disabled" class="mt-4">
        <template v-for="(error, i) in errors" :key="i">
            <n-alert class="rounded-md mb-4" type="warning" size="small">
                <div class="notes text-xs" v-html="error.msg"></div>
            </n-alert>
        </template>
    </section>

    <section class="mt-4">
        <template v-if="apiOptions === 'select'">
            <rb-select
                filterable
                :label="selectTitle"
                :options="apiKeys"
                :value="apiKeyValue"
                :loading="loading"
                :status="status"
                :msg="msg"
                :disabled="disabled || loading || !apiKeys.length"
                @update:value="$emit('update:modelValue', $event)" />
        </template>
        <template v-else>
            <rb-input
                v-for="(apiKey, key) in apiKeyModel"
                :key="key"
                class="mb-4"
                :status="apiKey.status === 'error' ? 'error' : undefined"
                :msg="apiKey.msg"
                :label="apiKey.title"
                :disabled="disabled || loading"
                :placeholder="apiKey.placeholder"
                v-model:value="apiKey.value"
                @update:value="apiKey.status = null, apiKey.msg = null" />

            <div class="flex justify-end items-center">
                <!-- <n-popover
                    v-if="exchangeMeta2Info"
                    style="width: 500px" trigger="hover" placement="right"
                    class="rounded-md bg-yellow-600">
                    <template #trigger>
                        <n-icon
                            class="cursor-pointer text-xl mx-2 text-yellow-600">
                            <Warning24Filled />
                        </n-icon>
                    </template>
                    <span
                        class="notes text-xs text-white"
                        v-html="exchangeMeta2Info">
                    </span>
                </n-popover> -->
                <n-button
                    strong
                    class="rounded-md text-white/90"
                    :color="gl.mainColor"
                    :loading="addApiLoading"
                    :disabled="disabled || createApiDisable || addApiLoading"
                    @click="onCreateApiKey">
                    {{ buttonLabel }}
                </n-button>
            </div>
        </template>
    </section>
</section>
</template>

<script>
// general
import general from './general';

// icons
import { Warning24Filled, QuestionCircle20Filled } from '@vicons/fluent';

// components
import RbInput from '@components/rb-input';
import RbSelect from '@components/rb-select';

// naive-ui
import {
    NIcon,
    NAlert,
    NInput,
    NSelect,
    NButton,
    NPopover,
    NRadioGroup,
    NRadioButton } from 'naive-ui';

export default {
    name: 'ApiKeys',
    emits: ['update:modelValue'],
    props: {
        modelValue: [String, Number],
        selectTitle: String,
        mainTitle: String,
        emptyText: String,
        status: String,
        msg: String,
        name: String,
        help: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        exchange: {
            type: Object,
            required: true,
        },
        apiKeysRefs: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'quick-start',
            validator: prop => ['quick-start', 'bots', 'marketplace'].includes(prop), 
        },
    },
    components: {
        NIcon,
        NAlert,
        NInput,
        NButton,
        RbInput,
        NSelect,
        RbSelect,
        NPopover,
        NRadioGroup,
        NRadioButton,
        Warning24Filled,
        QuestionCircle20Filled,
    },
    setup(props, context) {
        
        return {
            ...general(...arguments),
        };
    },
};
</script>